import ExpandablePill from "components/design-system/expandable-pill";
import { useWorkingFilter } from "hooks/use-working-filter";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../util/store-types";
import { displayModal } from "actions/shared-actions";
import { MODAL_NAMES } from "rtr-constants/modal-names";
import { isFilteredByShippingAddressNext } from "helpers/grid-top-filters-helpers";
import ZipInput from "./zip-input";
import GridTopFiltersAddressModal from "./grid-top-filters-address-modal";
import productsActions from "actions/products-actions";
import type { Address } from "@rtr/godmother";
import { isStorefrontNext } from "helpers/environment-helpers";
import { isActiveMembership } from "helpers/membership-helpers";
import { fetchMembershipRentalBegin } from "actions/membership-rental-begin-actions";

export type GridFilterModalZipSelectorProps = {
  onSubmitFilters: () => void;
};

const GridFilterModalZipSelector = ({ onSubmitFilters }: GridFilterModalZipSelectorProps) => {
  const [zipCode = "", setZipCode] = useWorkingFilter("zip_code", onSubmitFilters);
  const filteredByShippingAddress = useAppSelector(state => isFilteredByShippingAddressNext(state.userData));
  const isSubscriber = useAppSelector(state => isActiveMembership(state.membershipState));
  const [error, setError] = useState(false);

  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => {
    setError(false);
    setIsOpen(!isOpen);
  };

  const openShippingAddressModal = () => dispatch(displayModal(MODAL_NAMES.CHANGE_ADDRESS_FROM_GRID));

  const onClick = filteredByShippingAddress ? openShippingAddressModal : toggleAccordion;

  const onChangeZip = (zipCode: string) => {
    if (isStorefrontNext()) {
      dispatch(
        productsActions.refreshMembershipDepotIdCookie(zipCode, ({ zip_code }: { zip_code: string }) =>
          setZipCode(zip_code)
        )
      );
    } else {
      setZipCode(zipCode);
    }

    if (!isSubscriber) {
      dispatch(fetchMembershipRentalBegin(zipCode));
    }
  };
  const onChangeAddress = (address: Address) => {
    const { postalCode } = address;
    onChangeZip(postalCode);
  };

  const renderTitle = () => {
    return (
      <div>
        <span>Shipping zip code</span>
        {error && <span className="text-sm text-mutedRed ml-4">Enter complete zip</span>}
      </div>
    );
  };

  const renderSelectedZipAnnotation = () => {
    return isOpen ? null : <p data-test-id="selected-zip-annotation">{zipCode}</p>;
  };

  const renderZipInput = () => {
    return (
      <div className="flex items-center justify-between text-sm pb-4">
        <p>Where are we shipping to?</p>
        <ZipInput zipCode={zipCode} onZipSubmit={onChangeZip} error={error} setError={setError} classNames="max-w-24" />
      </div>
    );
  };

  return (
    <>
      <ExpandablePill
        leftAlignedHeader={renderTitle()}
        rightAlignedHeader={renderSelectedZipAnnotation()}
        expandedContent={renderZipInput()}
        classNames="min-h-14"
        isOpen={isOpen}
        onClick={onClick}
        toggleDataTestId="zip-selector-toggle"
      />
      <GridTopFiltersAddressModal onChange={onChangeAddress} />
    </>
  );
};

export default GridFilterModalZipSelector;
